import { useSignsBollardsStore } from '../../../../hooks/useSignsBollardsStore';

export const SelectedLocationTextContent = () => {
  const {
    data: { serviceLocationDetails, assetDetails, issueType },
  } = useSignsBollardsStore();

  let issueLabel = 'Sign';

  switch (issueType) {
    case 'Bollard':
      issueLabel = 'Bollard';
      break;
    case 'StreetNameplate':
      issueLabel = 'Street nameplate';
      break;
  }
  return (
    serviceLocationDetails.full_address && (
      <div className="text-bodyXl mt-4 flex flex-col gap-[1.25rem]">
        <p className="font-semibold text-black">{`Nearest address to the ${issueLabel}`}</p>
        <p className="font-normal text-black">
          {serviceLocationDetails.full_address}
        </p>
        {assetDetails?.central_asset_id && (
          <>
            <p className="font-semibold text-black">{`${issueLabel}`}</p>
            <p className="font-normal text-black">
              {`${issueLabel} selected ${assetDetails?.central_asset_id}`}
            </p>
          </>
        )}
      </div>
    )
  );
};
